// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISaveRealtorReportRequest,
  TSaveRealtorReportModel,
  IMappers,
  TSaveRealtorReportResponse,
  ISaveRealtorReportResponse,
  ISaveRealtorReportResponseError,
} from './types';

export const defaultConfig: TSaveRealtorReportModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v2/save-realtor-report/',
  requestType: 'json',
} as TSaveRealtorReportModel;

export function createSaveRealtorReportModel(parameters: ISaveRealtorReportRequest): TSaveRealtorReportModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISaveRealtorReportOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISaveRealtorReportRequest;
}

export async function fetchSaveRealtorReport<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveRealtorReportOptions<TResponse200, TResponse400>): Promise<
  TSaveRealtorReportResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createSaveRealtorReportModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISaveRealtorReportResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISaveRealtorReportResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSaveRealtorReportResponse;
}
